module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/panthers.3c66f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/panthers.png
// module id = oO6f
// module chunks = 0